<template>
  <div>
    <Card>
      <ui-count-input
        :min="0"
        :disabled="false"
      />
    </Card>
    <Card>
      <ui-count-input
        :disabled="true"
      />
    </Card>
  </div>
</template>

<script setup lang="ts">
import Card from '@/stories/utils/card.vue';

</script>
